import * as THREE from 'three'

import Experience from './Experience'

/** Perspective camera tuned for GoldSrc-scale maps (units are inches). */
export default class Camera {
  private readonly experience = Experience.instance
  public readonly instance: THREE.PerspectiveCamera

  constructor() {
    const { sizes } = this.experience

    this.instance = new THREE.PerspectiveCamera(
      75,
      sizes.width / sizes.height,
      0.5,
      16000,
    )
    this.instance.position.set(0, 64, 0)
    // Intentionally NOT added to the scene graph — a free camera lets the
    // renderer keep its world matrices in sync on every render.
  }

  /** Teleport to a spawn point. `angle` is a GoldSrc yaw in degrees. */
  public placeAt(position: THREE.Vector3, angle: number): void {
    this.instance.position.copy(position)
    const yaw = THREE.MathUtils.degToRad(angle)
    // GoldSrc yaw 0 = +X (east); +Y (north) maps to three -Z.
    const forward = new THREE.Vector3(Math.cos(yaw), 0, -Math.sin(yaw))
    this.instance.lookAt(position.clone().add(forward))
  }

  public resize(): void {
    const { sizes } = this.experience
    this.instance.aspect = sizes.width / sizes.height
    this.instance.updateProjectionMatrix()
  }
}
